import styled from "styled-components";

type Size = "medium" | "large";

export default styled.div<{ size?: Size }>`
  height: ${({ size }) => (size === "medium" ? "2.4rem" : "var(--toolbar-height)")};
`;
